import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cache from '../libs/common/cache'
import zhMessages from './messages/zh'
import vnMessages from './messages/vn'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n)

// 创建语言包
const messages = {
  zh: zhMessages,
  vn: vnMessages,
  en: {
    message: {
      hello: 'Welcome to log in to the YY Partner Client.',
      welcome: 'Welcome to use {{name}}'
    }
  }
}
class CustomFormatter {
  constructor() {
  }
  interpolate(message, values) {
    const reg = /{([^}]+)}/g
    return message.replace(reg, (match, key) => {
      // 使用 hasOwnProperty 检查，而不是依赖 truthy 判断
      return values && values.hasOwnProperty(key) ? values[key] : match
    })
  }
}

// 创建实例
const i18n = new VueI18n({
  locale: Cache.local.get('locale') || 'zh', // 从localStorage获取默认语言
  formatter: new CustomFormatter(),
  messages
})

locale.i18n((key, value) => i18n.t(key, value));

export default i18n